import {
  ClientErrorCode,
  WebInSessionError,
  WsError,
} from '@amzn/work-spaces-web-client-core-lib';
import { CoreFactory } from '@/bridge/factory/CoreFactory';
import { HeartbeatErrorControls } from '@/hooks/useReportHeartbeatTask';

const logger = CoreFactory.getLogger();

export const HEARTBEAT_RETRY_AFTER_ERROR_MS = 5 * 60 * 1000;

export const inSessionDisconnectUrl = (): string => {
  const port = window.location.port ? `:${window.location.port}` : '';
  return `https://${window.location.hostname}${port}/disconnect`;
};

export type HeartbeatErrorOutcome = 'retrying' | 'disconnecting';

export const handleHeartbeatError = (
  error: unknown,
  { retryAfter }: HeartbeatErrorControls
): HeartbeatErrorOutcome => {
  const isAuthError =
    error instanceof WsError &&
    error.clientErrorCode === ClientErrorCode.ReportHeartbeatAuthError;
  if (!isAuthError) {
    logger.info(
      `Heartbeat failed with a non-critical error ${
        error instanceof WsError ? error.clientErrorCode : error
      }. No disconnect, retrying in ${HEARTBEAT_RETRY_AFTER_ERROR_MS / 1000}s.`
    );
    retryAfter(HEARTBEAT_RETRY_AFTER_ERROR_MS);
    return 'retrying';
  }
  const url = new URL(inSessionDisconnectUrl());
  url.searchParams.set(
    WebInSessionError.DISCONNECT_ERROR_TYPE_SEARCH_NAME,
    WebInSessionError.WspErrorTypes.CLOSING_REASON
  );
  url.searchParams.set(
    WebInSessionError.DISCONNECT_STATUS_CODE_SEARCH_NAME,
    WebInSessionError.WspClosingReasonErrorCodes.SAML_HEART_BETA_UNAUTHORIZED
  );
  url.searchParams.set(
    'error_msg',
    'SAML_HEARTBEAT_UNAUTHORIZED_ERROR_CODE_1002'
  );
  logger.info(`Heartbeat authorization error, redirecting to: ${url.href}`);
  window.location.href = url.href;
  return 'disconnecting';
};
